import { CustomColumn } from '@dcl/ui/dist/fragments/DataGrid/DataGridTypes';
import {
  DATA_URL,
  NORMAL_HOURS,
  PAGE_DESCRIPTION,
  PAGE_TITLE,
  PH_NUMBER,
  PRODUCT_TTILE,
} from './constants';
import { ISupportHours, ISupportHoursTableHeader } from './SupportHoursTypes';

export const data = [
  {
    tabTitle: 'Customer Support',
    scheduleId: '1',
  },
  {
    tabTitle: 'Technical Support',
    scheduleId: '2',
  },
];

export const supportHoursMainMock: ISupportHours = {
  productTitle: PRODUCT_TTILE,
  normalHours: NORMAL_HOURS,
  phNumber: PH_NUMBER,
  pageTitle: PAGE_TITLE,
  pageDescription: PAGE_DESCRIPTION,
  dataUrl: DATA_URL,
  tabsData: data,
};

export const supportHoursWithoutTabs: ISupportHours = {
  productTitle: PRODUCT_TTILE,
  normalHours: NORMAL_HOURS,
  phNumber: PH_NUMBER,
  pageTitle: PAGE_TITLE,
  pageDescription: PAGE_DESCRIPTION,
  dataUrl: DATA_URL,
};

export const tableData: ISupportHoursTableHeader[] = [
  { Quarter: 'Quarter 1', Date: 'January 1', Day: 'Wednesday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'January 4', Day: 'Saturday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'January 5', Day: 'Sunday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'January 11', Day: 'Saturday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'January 12', Day: 'Sunday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'January 18', Day: 'Saturday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'January 19', Day: 'Sunday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'January 25', Day: 'Saturday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'January 26', Day: 'Sunday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'February 1', Day: 'Saturday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'February 2', Day: 'Sunday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'February 8', Day: 'Saturday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'February 9', Day: 'Sunday', Time: 'Closed' },
  {
    Quarter: 'Quarter 1',
    Date: 'February 15',
    Day: 'Saturday',
    Time: 'Closed',
  },
  { Quarter: 'Quarter 1', Date: 'February 16', Day: 'Sunday', Time: 'Closed' },
  {
    Quarter: 'Quarter 1',
    Date: 'February 22',
    Day: 'Saturday',
    Time: 'Closed',
  },
  { Quarter: 'Quarter 1', Date: 'February 23', Day: 'Sunday', Time: 'Closed' },
  {
    Quarter: 'Quarter 1',
    Date: 'March 1',
    Day: 'Saturday',
    Time: '9 AM to 6 PM',
  },
  {
    Quarter: 'Quarter 1',
    Date: 'March 2',
    Day: 'Sunday',
    Time: '9 AM to 6 PM',
  },
  {
    Quarter: 'Quarter 1',
    Date: 'March 8',
    Day: 'Saturday',
    Time: '9 AM to 6 PM',
  },
  {
    Quarter: 'Quarter 1',
    Date: 'March 9',
    Day: 'Sunday',
    Time: '9 AM to 6 PM',
  },
  {
    Quarter: 'Quarter 1',
    Date: 'March 15',
    Day: 'Saturday',
    Time: '9 AM to 6 PM',
  },
  {
    Quarter: 'Quarter 1',
    Date: 'March 16',
    Day: 'Sunday',
    Time: '9 AM to 6 PM',
  },
  {
    Quarter: 'Quarter 1',
    Date: 'March 17',
    Day: 'Monday',
    Time: '8 AM to Midnight',
  },
  {
    Quarter: 'Quarter 1',
    Date: 'March 22',
    Day: 'Saturday',
    Time: '9 AM to 6 PM',
  },
];

export const tableHeadings: CustomColumn<Record<string, string | number>>[] = [
  {
    Header: 'Quarter',
    accessor: 'col1',
    sortable: true,
    sortingAriaLabel: 'sort by Quarter',
    className: 'SupportHoursTable-Quarter',
    filterable: true,
  },
  {
    Header: 'Date',
    accessor: 'col2',
    sortable: true,
    sortingAriaLabel: 'sort by Date',
    className: 'SupportHoursTable-Date',
    filterable: true,
  },
  {
    Header: 'Day',
    accessor: 'col3',
    sortable: true,
    sortingAriaLabel: 'sort by Day',
    className: 'SupportHoursTable-Day',
    filterable: true,
  },
  {
    Header: 'Time',
    accessor: 'col4',
    sortable: true,
    sortingAriaLabel: 'sort by Time',
    className: 'SupportHoursTable-Time',
    filterable: true,
  },
];

export const tableBodyData = [
  { col1: 'Quarter 1', col2: 'January 1', col3: 'Wednesday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'January 4', col3: 'Saturday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'January 5', col3: 'Sunday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'January 11', col3: 'Saturday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'January 12', col3: 'Sunday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'January 18', col3: 'Saturday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'January 19', col3: 'Sunday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'January 25', col3: 'Saturday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'January 26', col3: 'Sunday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'February 1', col3: 'Saturday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'February 2', col3: 'Sunday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'February 8', col3: 'Saturday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'February 9', col3: 'Sunday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'February 15', col3: 'Saturday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'February 16', col3: 'Sunday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'February 22', col3: 'Saturday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'February 23', col3: 'Sunday', col4: 'Closed' },
  {
    col1: 'Quarter 1',
    col2: 'March 1',
    col3: 'Saturday',
    col4: '9 AM to 6 PM',
  },
  { col1: 'Quarter 1', col2: 'March 2', col3: 'Sunday', col4: '9 AM to 6 PM' },
  {
    col1: 'Quarter 1',
    col2: 'March 8',
    col3: 'Saturday',
    col4: '9 AM to 6 PM',
  },
  { col1: 'Quarter 1', col2: 'March 9', col3: 'Sunday', col4: '9 AM to 6 PM' },
  {
    col1: 'Quarter 1',
    col2: 'March 15',
    col3: 'Saturday',
    col4: '9 AM to 6 PM',
  },
  { col1: 'Quarter 1', col2: 'March 16', col3: 'Sunday', col4: '9 AM to 6 PM' },
  {
    col1: 'Quarter 1',
    col2: 'March 17',
    col3: 'Monday',
    col4: '8 AM to Midnight',
  },
  {
    col1: 'Quarter 1',
    col2: 'March 22',
    col3: 'Saturday',
    col4: '9 AM to 6 PM',
  },
];

export const FILTER_MOCK_DATA = [
  {
    accessor: 'col1',
    cols: [
      {
        option: '101e',
        selected: false,
      },
      {
        option:
          'Microsoft ended support for SQL 2012 and earlier on July 12, 2022. You should have SQL Server 2014 (Service Pack 3) or higher installed on machines that run Accounting CS.',
        selected: false,
      },
      {
        option:
          'zebra Microsoft ended support for SQL 2012 and earlier on July 12, 2022. You should have SQL Server 2014 (Service Pack 3) or higher installed on machines that run Accounting CS.',
        selected: false,
      },
    ],
    header: 'Title',
  },
  {
    accessor: 'col2',
    cols: [
      {
        option: 'Refer to ADO #758624 when talking to Support',
        selected: false,
      },
      {
        option: 'yaak Refer to ADO #758624 when talking to Support',
        selected: false,
      },
    ],
    header: 'Category',
  },
];
